// @flow
export { default } from './LetterComment';



// WEBPACK FOOTER //
// ./src/components/letter/LetterComment/index.js